export default class APIResponse {
    constructor(data, status, statuscode, msg) {
        this.data = data;
        this.status = status;
        this.statuscode = statuscode;
        this.msg = msg;
    }
}